import { render, staticRenderFns } from "./AppDeeplinkUpdater.vue?vue&type=template&id=e52fa2d8"
import script from "./AppDeeplinkUpdater.vue?vue&type=script&lang=ts"
export * from "./AppDeeplinkUpdater.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports